<template>
  <FormLabel :ok="ok" :text="text" :error="forceError || error" :increased="increased" :class="{'disabled':disabled, 'filled' : value}">
    <input class="formfield" :placeholder="placeholder" autocomplete="off"
           ref="input"
           :type="type"
           inputmode="numeric"
           :disabled="disabled"
           :name="name"
           v-maska="mask"
           v-model="val"
           @focus="fillStartMask"
           @blur="filledCheck">
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { maska } from 'maska'

export default {
  components: { FormLabel },
  mixins: [FormField],
  directives: { maska },
  props: {
    required: { type: Boolean, default: false },
    increased: { type: Boolean, default: false },
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    type: {type: String, default: 'text'},
    placeholder: {type: String},
    mask: {type: String},
    forceError: { type: String, default: '' },
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v?true:false},
    errorcont: { type: Object },
    disabled: { type: Boolean, default: false },
  },
  data: ()=>({
    error: '',
  }),
  computed:{
    ok(){
      if (!this.value || !this.filled(this.value) || this.error) return false
      return true
    },
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  methods:{
    fillStartMask(){
      if (this.mask && this.val.length < this.mask.match(/^[^#]*(?=#)/)[0].length) {
        this.val = this.mask.match(/^[^#]*(?=#)/)[0]
      }
    },
    filledCheck(){
      if (!this.filled(this.value) && this.required) 
        this.error = "Заполните поле"
    }
  },
  watch: {
    value(val, old){
      if (val != old)
        this.$emit('input', val)      
      this.error = ''
      if (val)
        this.error = this.validation(val) 
      if (!this.error && this.required) this.filledCheck()
    },
    error(val) {
      if (this.errorcont)
        this.$set(this.errorcont, this.name, val)
    },
  }
}
</script>

<style lang="sass">

</style>